export const routes = {
  LOGIN: "/",
  HOME: "/home",
  NO_ROLE: "/no-role",
  UNSUBSCRIBE: "/unsubscribe",
  DASHBOARD: "/home/dashboard",
  EMAILVERIFICATION: "/verify-email",
  RESETPASSWORD: "/reset-password/",
  FORGOTPASSWORD: "/forgot-password",
  CHANGEPASSWORD: "/home/change-password",
  CONTACT_US: "/contact-us",
  REQUEST_ACCESS: "/request-access",

  //Partner-management
  REQUESTS: "/home/partner-management/requests",
  PARTNERLIST: "/home/partner-management/partner-list",
  PARTNER_CREATE_PLAN: "/home/partner-management/partner-list/create-plan",
  CREATE_PLAN: "/home/partner-management/create-plan",
  PARTNERDETAILS: "/home/partner-management/partner-list/details",
  PARTNER_DETAILS_CHANGE_PLAN:
    "/home/partner-management/partner-list/details/change-plan",
  CREATE_CRM_PLAN: "/home/partner-management/crm-plans/create-new-plan",
  CRM_PAID_PLANS: "/home/partner-management/crm-plans/crm-paid-plan",
  CRM_NO_COST_PLAN: "/home/partner-management/crm-plans/no-cost-plan",
  CRM_TRIAL_PLANS: "/home/partner-management/crm-plans/trial-plans",
  CRM_CUSTOM_PLANS: "/home/partner-management/crm-plans/custom-plans",
  PARTNERLEADSLOG: "/home/partner-management/partner-list/details/leads-log",

  // Lead-management
  LEADLIST: "/home/lead-management/lead-list",
  CREATELEAD: "/home/lead-management/lead-details/create-lead",
  SOCIALIMPORTLEAD: "/home/lead-management/lead-details/social-import-lead",
  LEADCAPTUREFORM: "/home/lead-management/lead-capture-form",
  LEADQUALIFICATION: "/home/lead-management/lead-qualification",
  LEADCAPTURE: "/home/lead-management/lead-capture",
  LEADLOGS: "/home/lead-management/lead-logs",
  LEAD_REPORTS: "/home/lead-management/lead-reports",
  ASSIGNEDLEADS: "/home/lead-management/assigned-leads",
  LEADASSIGNMENT: "/home/lead-management/lead-assignment",
  UNASSIGNEDLEADS: "/home/lead-management/un-assigned-leads",
  APPROVEDLEADS: "/home/lead-management/un-assigned-leads/approved-leads",
  ASSIGNMENTRULES: "/home/lead-management/assignment-rules",
  ASSIGNMENTRULESLEADS: "/home/lead-management/assignment-rules/leads",
  ASSIGNMENTRULESCREATERULE:
    "/home/lead-management/assignment-rules/create-rule",
  ARCHIVEDASSIGNMENTRULES:
    "/home/lead-management/assignment-rules/archived-assignment-rules",
  LEADDETAILS: "/home/lead-management/lead-details",
  LEADCAPTUREFORMDETAILS: "/home/lead-management/lead-capture-form/details",
  //customer-management
  CUSTOMERLIST: "/home/customer-management/customer-list",
  CUSTOMERDETAILS: "/home/customer-management/customer-list/details",
  CREATECUSTOMER: "/home/customer-management/customer-list/create-customer",
  CUSTOMERENGAGEMENT: "/home/customer-management/customer-engagement",
  CUSTOMERSUPPORT: "/home/customer-support",
  SOCIALIMPORT_CUSTOMER:
    "/home/customer-management/customer-list/social-import-customer",

  // Campaigns
  CREATECAMPAIGN: "/home/campaigns/create-campaign",
  CAMPAIGNLIST: "/home/campaigns/campaign-list",
  CAMPAIGNDETAILS: "/home/campaigns/campaign-list/details",
  LANDINGPAGE: "/home/campaigns/landing-page",
  HUBSPOT: "/home/campaigns/hubspot",

  //Surveys and Emails & Letters
  VIEWSURVEY: "/home/surveys/view-survey",
  CREATESURVEY: "/home/surveys/create-survey",
  EMAILTEMPLATES: "/home/email-templates",
  LETTERTEMPLATES: "/home/letter-templates",
  CAMPAIGN_PERFORMANCE_METRICS: "/home/campaigns/campaign-performance-metrics",
  QRCODELIST: "/home/surveys/qr-code-list",
  UNSUBSCRIBED_USERS: "/home/surveys/unsubscribed-users-list",
  GENERAL_NOTES: "/home/general-notes",
  // Payments
  ORDERSLIST: "/home/payments/order-management/orders",
  ORDER_DETAILS: "/home/payments/order-management/orders/order-details",
  ORDER_DETAILS_CHANGE_PLAN:
    "/home/payments/order-management/orders/order-details/change-plan",
  INVOICELIST: "/home/payments/order-management/invoices",
  SUBSCRIPTIONREPORT: "/home/payments/subscription-report",

  // Footer-navigations

  //Settings
  PERSONAL_SETTINGS: "/home/settings/personal-settings",
  PROFILE: "/home/settings/personal-settings/profile",
  TRACK_UPLOADS: "/home/settings/track-uploads",

  //Myplans
  MY_PLANS: "/home/settings/myplans",
  USER_CHANGE_PLAN: "/home/settings/myplans/change-plan",

  COMPANY_PROFILE: "/home/settings/company-settings/profile",
  COMPANYSETTINGS: "/home/settings/company-settings",

  TERMSOFSERVICES: "/home/terms-of-services",
  NOTIFICATIONS: "/home/notifications",

  // User Management
  USER_REQUESTS: "/home/user-management/user-requests",
  USER_MANAGEMENT_LIST: "/home/user-management/user-management-list",
  USER_MANAGEMENT_ROLE: "/home/user-management/user-management-role",
  USER_REPORTS: "/home/user-management/user-reports",
  USER_MANAGEMENT_TERMSOFSERVICES: "/home/user-management/terms-of-services",

  //AFP Support
  SUPPORT_TICKETS: "/home/support-tickets",
  GUIDES: "/home/guides",
  AI_CALL_MONITORING: "/home/settings/ai-call-monitoring",
};
